const STORAGE_KEY = 'smart_banner_session_dismissals';
export const BANNER_DISMISSAL_EVENT = 'smart-banner-dismissal-changed';

const dismissalKey = (bannerId, companyId = '') =>
  `${String(bannerId)}::${String(companyId ?? '')}`;

export const getSessionDismissedBannerKeys = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
};

export const isBannerDismissedForSession = (bannerId, companyId = '') =>
  getSessionDismissedBannerKeys().includes(dismissalKey(bannerId, companyId));

export const dismissBannerForSession = (bannerId, companyId = '') => {
  const key = dismissalKey(bannerId, companyId);
  const keys = getSessionDismissedBannerKeys();
  if (!keys.includes(key)) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...keys, key]));
    window.dispatchEvent(new CustomEvent(BANNER_DISMISSAL_EVENT));
  }
};

export const clearSessionBannerDismissals = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
